import React from 'react';
import { Link } from 'react-router-dom';

const cities = {
  Michigan: [
    { name: 'Sterling Heights', slug: '/sterling', active: true },
    { name: 'West Bloomfield', active: false },
    { name: 'Troy', active: false },
    { name: 'St. Clair Shores', active: false },
  ],
  Arizona: [
    { name: 'Peoria', active: false },
    { name: 'Glendale', active: false },
    { name: 'Surprise', active: false },
    { name: 'Goodyear', active: false },
    { name: 'Avondale', active: false },
    { name: 'Buckeye', active: false },
    { name: 'Litchfield Park', active: false },
    { name: 'El Mirage', active: false },
  ],
};

const CityCard = ({ city }) => {
  if (city.active) {
    return (
      <Link
        to={city.slug}
        className="group flex items-center justify-between border-4 border-retro-brown bg-retro-cream rounded-2xl px-6 py-5 shadow-[4px_4px_0px_0px_rgba(58,44,39,1)] hover:shadow-[6px_6px_0px_0px_rgba(58,44,39,1)] hover:-translate-y-0.5 transition-all duration-150"
      >
        <span className="font-body font-bold text-lg text-retro-brown">{city.name}</span>
        <span className="font-body font-black text-xs bg-emerald-500 text-white border-2 border-slate-900 px-3 py-1 rounded-full uppercase tracking-widest">
          Available
        </span>
      </Link>
    );
  }

  return (
    <div className="flex items-center justify-between border-4 border-retro-brown/30 bg-retro-cream/50 rounded-2xl px-6 py-5 opacity-60 cursor-not-allowed">
      <span className="font-body font-bold text-lg text-retro-brown">{city.name}</span>
      <span className="font-body font-black text-xs bg-retro-brown/20 text-retro-brown border-2 border-retro-brown/30 px-3 py-1 rounded-full uppercase tracking-widest">
        Coming Soon
      </span>
    </div>
  );
};

const StateSection = ({ state, cities }) => (
  <div>
    <div className="flex items-center gap-4 mb-6">
      <h2 className="font-display text-4xl uppercase tracking-tighter text-retro-brown">{state}</h2>
      <div className="flex-1 h-1 bg-retro-brown/20 rounded-full" />
    </div>
    <div className="flex flex-col gap-3">
      {cities.map((city) => (
        <CityCard key={city.name} city={city} />
      ))}
    </div>
  </div>
);

const FindYourCity = () => (
  <div className="min-h-screen bg-retro-yellow/10">
    <div className="border-b-4 border-retro-brown bg-retro-teal py-16 px-6 text-center">
      <h1 className="font-display text-5xl md:text-7xl uppercase tracking-tighter text-retro-cream drop-shadow-[4px_4px_0_rgba(58,44,39,1)] mb-4">
        Find Your City
      </h1>
      <p className="font-body text-xl font-bold text-retro-cream/90 max-w-xl mx-auto">
        Select your city to check availability and claim your category before a competitor does.
      </p>
    </div>

    <div className="max-w-2xl mx-auto px-6 py-16 flex flex-col gap-14">
      {Object.entries(cities).map(([state, stateCities]) => (
        <StateSection key={state} state={state} cities={stateCities} />
      ))}
    </div>
  </div>
);

export default FindYourCity;
